import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import {
  getListOfAttachmentsByUserId,
  downloadAttachment,
  getCategoryManagementListQuery,
  getListOfCategoriesForDocUploadUserQuery,
  getListOfAttachmentsByUserIdForFolderQuery,
  getListOfCategoriesForCategoryViewUserQuery,
  sendEmailForDoc,
  getListofGenericMasterQueryForView,
  ViewSubCatAttachment,
} from "../../services/graphql/queries/category-management";
import { GET_PERMISSION, getAccessPermisionQuery } from "../../services/graphql/queries/accessPermission";

import DisplayErrors from "../Common/DisplayErrors";
import Pagination from "../Common/Pagination";
import NotAccessible from "../Common/NotAccessible";
import ReactModal from "../Common/ReactModal";

import {
  PAGINATION_OFFSET_VALUE,
  DO_NOT_ACCESS_MESSAGE,
  SET_TIMEOUT_VALUE,
} from "../../constants/app-constants";
import { errorMessage } from "../../miscellaneous/error-messages";

import downloadSvg from "../../static/images/download.svg";
import gridSvg from "../../static/images/grid.svg";
import SelectComponent from "../Common/form-component/SelectComponent";
import SimpleReactValidator from "simple-react-validator";
import { errorMsg,successMsg } from "../../miscellaneous/react-toastify";
import Emailnotify from "../../static/images/EmaildownBtn.svg";
import Modal from "react-awesome-modal";
import popupLogo from "../../static/images/popup-logo.png";
import { addPermission } from "../../services/redux/actions/loginActions";
import { GrFormView  } from "react-icons/gr";




import { result } from "lodash";
import { parse } from "path";
import InputComponent from "../Common/form-component/InputComponent";
import { getListofMasterQuery } from "../../services/graphql/queries/masters";

// import CategoryFilter from "./CategoryFilter";

const FileSaver = require("file-saver");
const mime = require("mime-types");

const CATEGORY_MANAGEMENT_MODULE_ID = 15;
const CATEGORY_MANAGEMENT_FEATURE_ID = 243;

class CategoryList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      tags: "",
      projectId: "",
      searchedTags: "",
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: DO_NOT_ACCESS_MESSAGE,
      accessSpecifier: null,
      departmentOption: [],
      selectedOption: null,
      userDetail: {
        entityType: "",
      },
      projectNameList: [],
      errors: [],
      downloadingAttachments:{},
      isDownloading:false,
      modalVisibleEmail:false,
      emailAttachment:{},
      emailProvider: {
        inputEmail: "",
      },
      sending:false,
      modalVisibleFOrMail:false,
      modalMail: "Email sent Successfully",
      accessPermission: [],

      projectQuery: "",
      filteredProjects: [],
      showSuggestions: false,
      master:[],
      allowedFormat:null,
      activeSuggestionIndex: -1,
      
    };
    this.submitModal = this.submitModal.bind(this);
    this.wrapperRef = React.createRef();
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        multipleEmails: {
          message: "Please enter valid and unique email addresses",
          rule: (value) => {
            if (!value) return false; // Required field check
            const emailPattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/;
            // Split emails, trim spaces, and validate each one
            // Convert value to string in case it's not
            const strValue = String(value);
            const emails = strValue.split(",").map((email) => email.trim());

            // Check for unique emails
            const uniqueEmails = new Set(emails);
            if (uniqueEmails.size !== emails.length) {
              return false; // if Duplicates found
            }

            return emails.every((email) => emailPattern.test(email));
          },
          required: true, //This ensures that the field must be filled in
        },
      },
      element: (message) => (
        <div style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
          {message}
        </div>
      ),
    });
    // this.validator = new SimpleReactValidator({
    //   autoForceUpdate: this,
    //   element: (message) => <div style={{ color: "red" }}>{message}</div>,
    //   reportingManagerId: {
    //     message: "Please select reporting manager",
    //     rule: (val, params, validator) => {
    //       if (this.state.userDetail.entityType == "2") {
    //         return true;
    //       } else {
    //         return false;
    //       }
    //     }
    //   }
    // });
  }
  // handleInput(e) {
  //   let value = e.target.value;
  //   let name = e.target.name;
  //   this.setState(prevState => {
  //     return {
  //       userDetail: {
  //         ...prevState.userDetail,
  //         [name]: value
  //       }
  //     };
  //   });
  //   if (name == "entityType" && parseInt(value) == 1) {
  //     this.state.userDetail.reportingManagerId = "";
  //     this.setState({
  //       ...this.state.userDetail,
  //       // isReportingManager: true,
  //       // reportingManagerMsg: ""
  //     });
  //   }
  //   if (name == "entityType" && parseInt(value) == 2) {
  //     this.setState({
  //       // isReportingManager: false
  //     });
  //   }
  //   // if ((name = "reportingManagerId" && value != "")) {
  //   //   this.setState({ reportingManagerMsg: "" });
  //   // }
  //   // if (this.state.userDetail.entityType == "1") {
  //   //   this.setState({ reportingManagerMsg: "" });
  //   // }
  // }
  handleInput = (e) => {
    console.log("handleInput",e.target.value);
    
    this.setState({
      userDetail: {
        ...this.state.userDetail,
        entityType: e.target.value,
      },
    });
    
  };

  submitModal() {
    this.setState({ reactModalVisible: false });
  }

  onChangePage(currentPage) {
    // update state with new page of items
    this.setState({
      currentPage: currentPage,
      loading: true,
    });
    this.getListOfAttachment(this.state.offset, currentPage);
  }

  getPermission() {
    this.props.client
      .query({
        query: GET_PERMISSION,
        fetchPolicy: "network-only",
      })
      .then((result) => {
        console.log(
          "notify permission for doc-search ",
          JSON.parse(result.data.getPermission)
        );
        this.setState(
          {
            accessPermission: JSON.parse(result.data.getPermission),
            //loading: true,
          },

          // () => {
          //   console.log(
          //     "Updated accessPermission",
          //     this.state.accessPermission
          //   );

          //   this.props.dispatch(addPermission(this.state.accessPermission));
          // }
        );
      })
      .catch((error) => {
        this.props.dispatch(addPermission({}));
        console.log("~~~error: ", error);
      });
  }

  // onClickOfAttachment(attachment) {
  //   if (attachment.attachmentType == 1) {
  //     this.setState((prevState)=>({
  //       downloadingAttachments:{
  //         ...prevState.downloadingAttachments,
  //         [attachment.id]:true,
  //       },
  //         isdownloading:true
  //     }))
  //     this.props.client
  //       .mutate({
  //         mutation: downloadAttachment,
  //         variables: {
  //           attachmentId: attachment.id,
  //         },
  //         fetchPolicy: "no-cache",
  //       })
  //       .then((result) => {
  //         let attachmentData = result.data.downloadSubCatAttachment;

  //         let presignedUrl = attachmentData?.fileData; // Get pre-signed URL

  //         let fileName = attachmentData?.fileName;

  //         if (!presignedUrl || !fileName) {
  //           console.error("Presigned URL or filename is missing!");
  //           return;
  //         }
    
  //         // Modify filename by removing the first 32 characters
  //         let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

  //         let link = document.createElement("a");
  //         link.href = presignedUrl;
  //         link.setAttribute("download", modifiedFileName); 
  //         document.body.appendChild(link);
  //         link.click();
  //         document.body.removeChild(link);
  //         successMsg("Download Initiated");
  //         this.setState({
  //           errors: [],
  //           loading: false,
  //           isdownloading:false
  //         });
  //         this.setState((prevState) => ({
  //           downloadingAttachments: {
  //             ...prevState.downloadingAttachments,
  //             [attachment.id]: false, // Reset only the clicked attachment/Download file
  //           },
  //         }));
  //       })
  //       .catch((error) => {
  //         console.log("~~~error: ", error);
  //         this.setState({ loading: false, errors: [errorMessage(error)] });
  //         this.setState((prevState) => ({
  //           downloadingAttachments: {
  //             ...prevState.downloadingAttachments,
  //             [attachment.id]: false, 
  //           },
  //         }));
  //         this.timer = setTimeout(() => {
  //           this.setState({ errors: [] });
  //         }, SET_TIMEOUT_VALUE);
  //       });
  //   } else {
  //     let data = { GridId: attachment.gridId.id };
  //     localStorage.setItem("GridId-Input", JSON.stringify(data));
  //     // this.props.history.push("/grid-input-edit");
  //     window.open("/grid-input-edit");
  //   }
  // }

  // onClickOfAttachment(attachment) {
  //     if (attachment.attachmentType == 1) {
  //       this.setState((prevState) => ({
  //         downloadingAttachments: {
  //           ...prevState.downloadingAttachments,
  //           [attachment.id]: true, // Set only the clicked attachment as downloading
  //         },
  //         isDownloading:true
  //       }));
  //       // successMsg("Downloading File, please wait...");
  
  //       this.props.client
  //         .mutate({
  //           mutation: downloadAttachment,
  //           variables: {
  //             attachmentId: attachment.id,
  //           },
  //           fetchPolicy: "no-cache",
  //         })
  //         .then(async(result) => {
  
  //           let attachmentData = result.data.downloadSubCatAttachment;
  
  //           let presignedUrl = attachmentData?.fileData; // Get pre-signed URL
  //           console.log("presignedurl",presignedUrl);
            
  
  //           let fileName = attachmentData?.fileName;
  //           console.log("filename",attachmentData);
            
            
  
  //           if (!presignedUrl || !fileName) {
  //             console.error("Presigned URL or filename is missing!");
  //             this.setState({ isDownloading: false });
  //             return;
  //           }
      
  //           // Modify filename by removing the first 32 characters
  //           let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;
  
  //           // let link = document.createElement("a");
  //           // link.href = presignedUrl;
  //           // // link.setAttribute("download", modifiedFileName); 
  //           // link.target="_blank";
  //           // document.body.appendChild(link);
  //           // link.click();
  //           // document.body.removeChild(link);
  
  //           const ext = fileName.split(".").pop().toLowerCase();
  
  //           const officeExts = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];
  //           const inlineExts = ["pdf", "jpg", "jpeg", "png", "gif"];
  
  //           let openUrl=presignedUrl;
            
  
  //           if (officeExts.includes(ext)) {
  //             openUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(presignedUrl)}`;
  //           }
    
  //           if (inlineExts.includes(ext) || officeExts.includes(ext)) {
  //             // window.open(openUrl, "_blank");
  //             const newWindow = window.open("", "_blank");
  //           if (newWindow) {
  //             const html = `
  //               <html>
  //                 <head>
  //                   <title>${modifiedFileName}</title>
  //                 </head>
  //                 <body style="margin:0">
  //                   <iframe src="${openUrl}" style="width:100%; height:100vh; border:none;"></iframe>
  //                 </body>
  //               </html>
  //             `;
  //             newWindow.document.write(html);
  //             newWindow.document.close();
  //           }
               
  //           } else {
  //             // Force download (e.g., zip, rar)
  //             const link = document.createElement("a");
  //             link.href = presignedUrl;
  //             link.setAttribute("download", fileName);
  //             document.body.appendChild(link);
  //             link.click();
  //             document.body.removeChild(link);
  //           }
  
  //           successMsg("Download Initiated");
  //           this.setState({
  //             errors: [],
  //             loading: false,
  //             isDownloading:false
  //           });
  //           this.setState((prevState) => ({
  //             downloadingAttachments: {
  //               ...prevState.downloadingAttachments,
  //               [attachment.id]: false, // Reset only the clicked attachment/download File
  //             },
  //           }));
  //         })
  //         .catch((error) => {
  //           console.log("~~~error in download: ", error);
  //           let message = errorMessage(error);
  //           errorMsg(message[0]);
  //           this.setState({
  //             loading: false,
  //             errors: [errorMessage(error)],
  //           });
  //           setTimeout(() => {
  //             this.setState({ isDownloading: false });
  //           }, 3000);
  //           this.setState((prevState) => ({
  //             downloadingAttachments: {
  //               ...prevState.downloadingAttachments,
  //               [attachment.id]: false, 
  //             },
  //           }));
  //           this.timer = setTimeout(() => {
  //             this.setState({ errors: [] });
  //           }, SET_TIMEOUT_VALUE);
  //         });
  //     } else {
  //       let data = { GridId: attachment.gridId.id };
  //       localStorage.setItem("GridId-Input", JSON.stringify(data));
  //       // this.props.history.push("/grid-input-edit");
  //       window.open("/grid-input-edit");
  //     }
  //   }

onClickOfAttachment(attachment) {
    if (attachment.attachmentType == 1) {
      this.setState((prevState) => ({
        downloadingAttachments: {
          ...prevState.downloadingAttachments,
          [attachment.id]: true, // Set only the clicked attachment as downloading
        },
        isDownloading:true
      }));
      // successMsg("Downloading File, please wait...");

      this.props.client
        .mutate({
          mutation: downloadAttachment,
          variables: {
            attachmentId: attachment.id,
          },
          fetchPolicy: "no-cache",
        })
        .then(async(result) => {

          let attachmentData = result.data.downloadSubCatAttachment;

          let presignedUrl = attachmentData?.fileData; // Get pre-signed URL

          let fileName = attachmentData?.fileName;

          if (!presignedUrl || !fileName) {
            console.error("Presigned URL or filename is missing!");
            this.setState({ isDownloading: false });
            return;
          }
    
          // Modify filename by removing the first 32 characters
          let modifiedFileName = fileName.length > 32 ? fileName.substr(32) : fileName;

          let link = document.createElement("a");
          link.href = presignedUrl;
          link.setAttribute("download", modifiedFileName); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          successMsg("Download Initiated");
          this.setState({
            errors: [],
            loading: false,
            isDownloading:false
          });
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, // Reset only the clicked attachment/download File
            },
          }));
        })
        .catch((error) => {
          console.log("~~~error in download: ", error);
          let message = errorMessage(error);
          errorMsg(message[0]);
          this.setState({
            loading: false,
            errors: [errorMessage(error)],
          });
          setTimeout(() => {
            this.setState({ isDownloading: false });
          }, 3000);
          this.setState((prevState) => ({
            downloadingAttachments: {
              ...prevState.downloadingAttachments,
              [attachment.id]: false, 
            },
          }));
          this.timer = setTimeout(() => {
            this.setState({ errors: [] });
          }, SET_TIMEOUT_VALUE);
        });
    } else {
      let data = { GridId: attachment.gridId.id };
      localStorage.setItem("GridId-Input", JSON.stringify(data));
      // this.props.history.push("/grid-input-edit");
      window.open("/grid-input-edit");
    }
  }

  
handleProjectInputChange = (e) => {
  const query = e.target.value;
  const filtered = this.state.projectNameList.filter((project) =>
    (`[${project.projectId}] ${project.name}`.toLowerCase().includes(query.toLowerCase()))
  );

  this.setState({
    projectQuery: query,
    filteredProjects: filtered,
    showSuggestions: true,
    activeSuggestionIndex: -1,
    
  });
};

handleSelectProject = (project) => {
  console.log("project",project);
  
  const selectedProjectId = project.id;
  this.setState({
    selectedProject: selectedProjectId,
    projectQuery: `[${project.projectId}] ${project.name}`,
    showSuggestions: false,
    userDetail: {
      ...this.state.userDetail,
      entityType: project.id, 
    },
    filteredProjects:this.state.projectNameList,
    activeSuggestionIndex: -1,
  });
  // this.getListOfFolders(selectedProjectId); 
};

handleKeyDown = (e) => {
  const { activeSuggestionIndex, filteredProjects,projectQuery} = this.state;

  if (!filteredProjects || filteredProjects.length === 0) return;

  if (e.key === "ArrowDown") {
    e.preventDefault();
    const nextIndex =
      activeSuggestionIndex < filteredProjects.length - 1
        ? activeSuggestionIndex + 1
        : 0; 
    this.setState({ activeSuggestionIndex: nextIndex });
  } else if (e.key === "ArrowUp") {
    e.preventDefault();
    const prevIndex =
      activeSuggestionIndex > 0
        ? activeSuggestionIndex - 1
        : filteredProjects.length - 1;
    this.setState({ activeSuggestionIndex: prevIndex });
  } else if (e.key === "Enter") {
    e.preventDefault();

    let selected=null;
    if (activeSuggestionIndex >= 0) {
        selected = filteredProjects[activeSuggestionIndex];
    }
  else if (projectQuery.trim() === "") {
      selected = filteredProjects[0];
    }

    if (selected) {
      this.handleSelectProject(selected);
    }
  }
};

  getListOfAttachment(offset, pageNo) {
    let tags = document.getElementById("tag").value;
    console.log("tages",tags);
    
    const categoryIds = this.state.projectNameList.map(item => item.id);
    console.log("categoryIds",categoryIds);
    

    // categoryIds.map(cId=>{
    //   if (tags != "") {
    //     this.props.client
    //       .query({
    //         query: getListOfAttachmentsByUserIdForFolderQuery,
    //         variables: {
    //           offset: offset,
    //           pageNo: pageNo,
    //           tags: tags,
    //           categoryId:cId,
              
    //         },
    //         fetchPolicy: "network-only",
    //       })
    //       .then((result) => {
    //         var category = result.data.getListOfAttachmentsByUserIdForFolder;
    //         console.log("category",category);
            
  
    //         this.initialState = {
    //           pageOfItems: category,
              
    //         };
    //         this.setState({
    //           ...this.initialState,
    //           loading: false,
    //           error: "",
    //           searchedTags: tags,
    //         });
    //       })
    //       .catch((error) => {
    //         this.setState({ loading: false, error: error.message });
    //       });
    //   } else {
    //     this.setState({ pageOfItems: [], searchedTags: tags, tags: tags });
    //   }
    // })
    if (tags != "") {
      this.props.client
        .query({
          query: getListOfAttachmentsByUserIdForFolderQuery,
          variables: {
            offset: offset,
            pageNo: pageNo,
            tags: tags,
            categoryId:parseInt(this.state.userDetail.entityType),
            
          },
          fetchPolicy: "network-only",
        })
        .then((result) => {
          var category = result.data.getListOfAttachmentsByUserIdForFolder;
          console.log("category",category);
          

          this.initialState = {
            pageOfItems: category,
            
          };
          this.setState({
            ...this.initialState,
            loading: false,
            error: "",
            searchedTags: tags,
            
          });
        })
        .catch((error) => {
          this.setState({ loading: false, error: error.message });
        });
    } else {
      this.setState({ pageOfItems: [], searchedTags: tags, tags: tags });
    }
  }

  handleOutsideClick = (e) => {
  if (
    this.wrapperRef.current &&
    !this.wrapperRef.current.contains(e.target)
  ) {
    this.setState({ showSuggestions: false });
  }
};

  getListOfCategory() {
    this.props.client
      .query({
        query: getListOfCategoriesForCategoryViewUserQuery,
        variables: {},
        fetchPolicy: "network-only",
      })
      .then((result) => {
        var category = result.data.getListOfCategoriesForCategoryViewUser;
        
        console.log("categro",category);
        
        
        const categoryIds = category?.map(item => item?.id);

        if (categoryIds?.length > 0){
          this.initialState = {
            projectNameList: category,
            userDetail: {
              ...this.state.userDetail,
              entityType: categoryIds[0],
            },
            projectQuery:
            categoryIds &&
            `[${category[0].projectId}] ${category[0].name}`,
            filteredProjects: category,
          };
          this.setState({ ...this.initialState });
        }
      })
      .catch((error) => {
        let message = errorMessage(error);
        errorMsg(message[0]);
        this.setState({ loading: false, error: error.message });
      });
  }
  
  onModalForEmail(attachment) {
    this.setState({
      modalVisibleEmail: !this.state.modalVisibleEmail,
      emailAttachment: attachment,
    });
  }

  handleChange = (e) => {
    const { value } = e.target;
    this.setState((prevState) => ({
      emailProvider: {
        ...prevState.emailProvider,
        inputEmail: value, // Update email input
      },
    }));
    this.validator.showMessages(); // Force validation message update
  };

  sendEmail(emailAttachment) {
    if (this.validator.allValid()) {
      const emailList = this.state.emailProvider.inputEmail
        .split(",")
        .map((email) => email.trim());

      // Remove duplicate emails
      const uniqueEmailList = [...new Set(emailList)];
     
      let emailProvider = {
        inputEmail: "",
      };

      this.validator.hideMessages();
      this.setState({
       // loading: true,
        modalVisibleEmail: true,
        emailProvider,
        sending: true,
      });
      this.setState({ sending: true, modalVisibleEmail: true }, () => {
        this.props.client
          .query({
            query: sendEmailForDoc,
            variables: {
              attachmentId: emailAttachment.id,
              attachmentName: emailAttachment.name,
              emailUsers: uniqueEmailList,
            },

            fetchPolicy: "network-only",
          })
          .then((result) => {
            console.log("result", result);
            if (result?.data) {
              let responseMessage = JSON.parse(
                result?.data?.sendEmailforDocument
              );
              let msg = responseMessage?.message;
              console.log("parsed responseMessage", msg);
              if (msg.includes("Emails sent successfully")) {
                msg="Email/s sent successfully"
                this.setState({
                  modalVisibleFOrMail: true,
                  sending: false,
                  loading:false,
                  modalVisibleEmail: false,
                  modalMail: <span style={{ color: "green" }}>{msg}</span>,
                });
              } else {
                this.setState({
                    modalVisibleFOrMail: true,
                  sending: false,
                  //loading:false,
                  modalVisibleEmail: false,

                  modalMail: <span style={{ color: "red" }}>{msg}</span>,
                });
              }
            }
          })
          .catch((error, result) => {
            console.log("~~~error:send email ", error);

            let message = errorMessage(error);

            // Extracting error message
            let errorMsgText = message[0];
            console.log("message", errorMsgText);

            this.setState({
              sending: false,
              loading: false,
              errors: [errorMsgText],
            });

            console.log("error", this.state.errors);

            this.timer = setTimeout(() => {
              this.setState({ errors: [] });
            }, SET_TIMEOUT_VALUE);
          });
      });
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
submitModalForMail=()=>{
  this.setState({ modalVisibleFOrMail: false, modalMail: "" });
}
  onEmailCancelModalVisible() {
    let emailProvider = {
      inputEmail: [],
    };
    this.validator.hideMessages();
    this.setState({
      modalVisibleEmail: !this.state.modalVisibleEmail,
      emailProvider: emailProvider,
      
    });
  }
 


  // getListOfCategory() {
  //   this.props.client
  //     .query({
  //       query: getListOfCategoriesForDocUploadUserQuery,
  //       variables: {},
  //       fetchPolicy: "network-only",
  //     })
  //     .then((result) => {
  //       var category = result.data.getListOfCategoriesForDocUploadUser;
  //       const categoryIds = category?.map(item => item?.id);

  //       this.initialState = {
  //         projectNameList: category,
  //         userDetail: {
  //           ...this.state.userDetail,
  //           entityType: categoryIds[0],
  //         },
  //       };
  //       this.setState({ ...this.initialState });
  //     })
  //     .catch((error) => {
  //       let message = errorMessage(error);
  //       errorMsg(message[0]);
  //       this.setState({ loading: false, error: error.message });
  //     });
  // }
  

getMaster() {
        this.props.client
          .query({
            query: getListofMasterQuery,
            variables: {
              descriptionName: this.state.description,
              offset: this.state.offset,
              pageNo: this.state.currentPage,
            },
            fetchPolicy: "network-only",
          })
          .then((result) => {
            const master = result.data.getListofMaster;
  
            console.log("master",master);
            
            
            
            this.setState({
              master:[...master],
              // pageOfItems: master,
              loading: false,
              error: "",
            });
          })
          .catch((error) => {
            console.log("~~~error: ", error);
            this.setState({ loading: false, error: error.message });
          });
      }

  onClickOfMasterFile(attachment) {
    console.log("attachment", attachment);
  
    const masterObj = this.state.master.find(
      (m) => m.description === "File Formats for view"
    );
  
    if (!masterObj) {
      console.error("Master not found for File Formats for view!");
      return;
    }
    const masterForId = masterObj.Id;
  
    // Fetch allowed file formats dynamically
    this.props.client
      .query({
        query: getListofGenericMasterQueryForView,
        variables: { masterFor: masterForId },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        const formats = result.data.getListofGenericMaster.map((item) =>
          item.description.toLowerCase()
        );
  
        console.log("Supported formats:", formats);
        // Get presigned URL for viewing
        this.props.client
          .mutate({
            mutation: ViewSubCatAttachment,
            variables: { attachmentId: attachment.id },
            fetchPolicy: "no-cache",
          })
          .then((res) => {
            const data = res.data.viewSubCatAttachment;
            const fileUrl = data?.fileData;
            const fileName = data?.fileName;
            if (!fileUrl || !fileName) {
              console.error("Presigned URL or file name missing!");
              return;
            }
            const ext = fileName.split(".").pop().toLowerCase();
  
            if (!formats.includes(ext)) {
              errorMsg(`File format .${ext} not supported for view`);
              return;
            }
  
            // Office file extensions
            const officeExts = formats.filter((f) =>
              ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(f)
            );
  
            const imageExts = ["jpg", "jpeg", "png"];

            let openUrl = "";
          if (officeExts.includes(ext)){
            openUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
          } else if (imageExts.includes(ext)) {
            const imageHtml = `
              <html>
                <head>
                  <style>
                    body {
                      margin: 0;
                      background: #000;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 100vh;
                    }
                    img {
                      max-width: 100%;
                      max-height: 100%;
                      object-fit: contain;
                    }
                  </style>
                </head>
                <body>
                  <img src="${fileUrl}" alt="${fileName}" />
                </body>
              </html>
            `;
            const blob = new Blob([imageHtml], { type: "text/html" });
            openUrl = URL.createObjectURL(blob);
          } else {
            openUrl = fileUrl; // PDF or other viewable types
          }
  
            const newWindow = window.open("", "_blank");
          if (newWindow) {
            const faviconLink =
              document.querySelector("link[rel='icon']")?.href ||
              `${window.location.origin}/favicon.ico`;
              console.log("faviconLink", faviconLink);
              
            const html = `
              <html>
                <head>
                  <title>${fileName}</title>
                  <link rel="icon" type="image/png" href="${faviconLink}" />
                </head>
                <body style="margin:0">
                  <iframe src="${openUrl}" style="width:100%; height:100vh; border:none;"></iframe>
                </body>
              </html>
            `;
            const blob = new Blob([html], { type: "text/html" });
            const blobUrl = URL.createObjectURL(blob);
            newWindow.location.href = blobUrl;
          }
          else {
            console.warn("Unable to open new tab (popup blocked?)");
          }
        })
        .catch((error) => {
          console.error("Error getting presigned URL:", error.message);
        });
    })
    .catch((error) => {
      console.error("Error fetching formats:", error.message);
    });
  }

  fetchAllowedFormats = () => {
    const masterObj = this.state.master.find(
      (m) => m.description === "File Formats for view"
    );
  
    if (!masterObj) return;
    this.props.client
      .query({
        query: getListofGenericMasterQueryForView,
        variables: { masterFor: masterObj.Id },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        const formats = result.data.getListofGenericMaster.map((item) =>
          item.description.toLowerCase()
        );
        this.setState({ allowedFormat: formats });
      })
      .catch((error) => {
        console.error("Error fetching formats:", error.message);
      });
  };
  
  isViewSupported = (attachment) => {
    const { allowedFormat } = this.state;
    console.log("affff",attachment);
    
    // If formats are not loaded yet, temporarily enable icons
    if (!allowedFormat) return true;
  
    const ext = attachment.name?.split(".").pop().toLowerCase();
    console.log("isvewsupp",ext);
    
    return allowedFormat.includes(ext);
  };

  componentDidMount() {
    this.getPermission();
    this.getListOfCategory();
    setTimeout(() => {
    this.getMaster();
  }, 0);
    
    document.addEventListener("mousedown", this.handleOutsideClick);
    this.setState({
      loading: true,
    });

    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: CATEGORY_MANAGEMENT_MODULE_ID,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response[CATEGORY_MANAGEMENT_FEATURE_ID],
          loading: false,
        });

      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
    prevState.master !== this.state.master &&
    this.state.master.length > 0
  ) {
    this.fetchAllowedFormats(); // master is now ready
  }
}

  getCategoryBreadcrumb(categoryStructure) {
    var name = "";
    categoryStructure = JSON.parse(categoryStructure);
    const arrayLength = categoryStructure.length;
    for (let i = 0; i < arrayLength; i++) {
      if (arrayLength === i + 1) {
        // last element
        name = name + categoryStructure[i];
      } else {
        // not last element
        name = name + categoryStructure[i] + " -> ";
      }
    }
    // })
    return name;
  }

  render() {
     console.log("accesspermissson",this.state.accessPermission);
    
    console.log("pn", this.state.projectNameList);
    const {
      loading,
      error,
      accessSpecifier,
      accessPermission,
      reactModalVisible,
      modalVisibleFOrMail,
      requireCancel,
      modalMessage,
      modalMail,
      pageOfItems,
      tags,
      searchedTags,
      projectNameList,
      userDetail,
      emailProvider,
      emailAttachment
    } = this.state;
    // const activeProjectOptions = projectNameList.filter(
    //   (project) => project.statusDetail?.name === "Active"
    // );
    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <>
        {/* {this.state.isdownloading && (
          <div
            style={{
              
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "rgba(255, 255, 255, 0.9)", 
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", 
              zIndex: 1000,
              width: "350px",
              height: "70px", 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              
            }}
          >
            <div>
              <p style={{}}>
                <div className="uploading-container">
                  <span className="uploading-text" style={{fontSize:""}}>Downloading</span>
                  <span className="uploading-dot dot-1">.</span>
                  <span className="uploading-dot dot-2">.</span>
                  <span className="uploading-dot dot-3">.</span>
                  <span className="uploading-dot dot-4">.</span>
                  <span className="uploading-dot dot-5">.</span>
                </div>
              </p>
            </div>
          </div>
        )} */}
        {accessSpecifier && accessSpecifier.viewP ? (
          <div>
            <>
            <ReactModal
              reactModalVisible={reactModalVisible}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />
            <ReactModal
          reactModalVisible={modalVisibleFOrMail}
          modalMessage={modalMail}
          submitModal={this.submitModalForMail}
        />
            <div className="row align-items-center no-gutters">
              <div className="col-md-8">
                <h1 className="heading m-b-0">Document Search</h1>
              </div>
              <div className="col-md-4 text-right"></div>
            </div>
            <div className="row mt-3">
            <div className="col-md-3 col-lg-3">
                <div className="form-group position-relative" ref={this.wrapperRef}>
                  {console.log("handle value",this.state.userDetail.entityType)} 
                  {/* <SelectComponent
                    title={"Project"}
                    name={"Project"}
                    options={projectNameList.map((project) => ({
                      id: project.id,
                      name: `[${project.projectId}]  ${project.name}`, // Concatenating projectId and name
                    }))}
                    optionKey={"name"}
                    valueKey={"id"}
                    placeholder="Select Project"
                    value={userDetail.entityType || ""} 
                    handleChange={this.handleInput} 
                  /> */}

                  <input
                type="text"
                className="form-control"
                placeholder="Type to search project"
                value={this.state.projectQuery}
                onChange={this.handleProjectInputChange}
                onClick={() => {
                  // if (this.state.projectQuery) this.setState({ showSuggestions: true });
                  this.setState({
                        showSuggestions: true,
                        activeSuggestionIndex: this.state.filteredProjects.findIndex(
                                  (p) => p.id === this.state.selectedProject
                          ),
                  });
                }}
                onKeyDown={this.handleKeyDown}
                required
                validator={this.validator}
                validation="required"
                optionKey={"name"}
                valueKey={"id"}
            />

              {this.state.showSuggestions && (
                <ul
                  className="suggestions-list"
                  style={{
                    position: "absolute",
                    top: "90%",
                    left: 0,
                    right: 0,
                    // minWidth:"93%",
                    maxHeight: "auto", //240px
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    zIndex: 1000,
                    listStyleType: "none",
                    margin: 0,
                    padding: 0,
                    maxHeight:"40vh",
                  }}
                  ref={(el) => (this.suggestionsListRef = el)}
      >
      {this.state.filteredProjects.length > 0 ? (
        this.state.filteredProjects.map((project, index) => {
          // <li
          //   key={project.id}
          //   style={{ padding: "8px", cursor: "pointer" ,backgroundColor: project.id === this.state.selectedProject ? "#f0f0f0" : "#fff" }}
          //   onClick={() => this.handleSelectProject(project)}
          // >
          //   [{project.projectId}] {project.name}
          // </li>
          const isHovered = project.id === this.state.hoveredProjectId;
          const isSelected = project.id === this.state.userDetail.entityType;
          const isActive = index === this.state.activeSuggestionIndex;

          return (
            <li
              key={project.id}
              ref={(el) => {
                            if (isActive && el) {
                              el.scrollIntoView({
                                block: "nearest", 
                              });
                            }
                    }}
              style={{
                padding: "6px 8px",
                cursor: "pointer",
                backgroundColor: isSelected
                          ? "#007bff"      // blue 
                          : isActive
                          ? "#cce5ff"        // lighter blue 
                          : isHovered
                          ? "#f0f0f0"        // gray 
                          : "#fff",
                color: isSelected ? "#fff" : "#000",
                fontSize: "15px",
              }}
              onMouseEnter={() =>
                this.setState({ hoveredProjectId: project.id })
              }
              onMouseLeave={() => this.setState({ hoveredProjectId: null })}
              onClick={() => this.handleSelectProject(project)}
            >
              [{project.projectId}] {project.name}
            </li>
          );
        })
      ) : (
        <li style={{ padding: "8px" }}>No matching projects</li>
      )}
    </ul>
  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <input
                    type="text"
                    id="tag"
                    className="form-control"
                    value={tags}
                    placeholder="Enter tags to search(minimum 3 characters)"
                    onChange={(e) => this.setState({ tags: e.target.value })}
                    onKeyUp={(e) => {
                      if (e.which == 13 || e.keyCode == 13) {
                        e.preventDefault();
                        this.getListOfAttachment(
                          this.state.offset,
                          this.state.currentPage
                        );
                        return false;
                      }
                      return true;
                    }}
                  />
                </div>
              </div>
             
              <div className="col-md-3 ">
                <button
                  type="button"
                  className="btn btn-danger "
                  onClick={() =>
                    this.getListOfAttachment(
                      this.state.offset,
                      this.state.currentPage
                    )
                  }
                >
                  Go 
                </button>
              </div>
            </div>
            <div>
              <div
                className="form-group "
                style={{ padding: "0px", margin: "0px" }}
              >
                {searchedTags != "" ? (
                  <span>
                    <label style={{ marginRight: "5px" }}>
                      Search result for tag:{" "}
                    </label>
                    {searchedTags}
                  </span>
                ) : null}

              <div
                className="row"
                style={{
                  display: this.state.errors.length === 0 ? "none" : "block",
                }}
              >
                <div className="col-md-6">
                  <div className="alert alert-success" role="alert">
                    <div className="row">
                      <span className="danger-link">
                        <DisplayErrors errors={this.state.errors} />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
                </div>
              </div>
            <div className="table-responsive">
              <table className="table table-style-1">
                <thead>
                  <tr>
                    <th scope="col">PROJECT</th>
                    <th scope="col">TYPE</th>
                    <th scope="col">NAME</th>
                    <th scope="col">DESCRIPTION</th>
                    <th scope="col" className="m-r-70">
                      <div className="text-center bg-primar" style={{width:"53%"}}>
                        <span className="m-r-70 bg-inf">ACTION(s)</span>{" "}
                      </div>
                      {/* ACTION(s) */}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pageOfItems.length
                    ? pageOfItems.map((data, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              {this.getCategoryBreadcrumb(
                                data.categoryStructure
                              )}
                            </td>
                            <td>
                              {data.attachmentType == 1 ? "Document" : "Grid"}
                            </td>
                            <td
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title={data.name}
                            >
                              {data.name.length > 40
                                ? data.name.substring(0, 40) + "..."
                                : data.name}
                            </td>
                            <td>{data.description}</td>
                            <td className="">
                              {data.attachmentType == 2 ? (
                                <a
                                  className="link-click"
                                  href={"/grid-input-edit?id=" + data.gridId.id}
                                  target="_blank"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Go To Grid"
                                  onClick={() => this.onClickOfAttachment(data)}
                                >
                                  <img src={gridSvg} alt="" />
                                </a>
                              ) : (
                                <> 
                                {/* <a className="link-click"
                                    href="#"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="View"
                                    onClick={(e) => {
                                     e.preventDefault(); // prevent page jump
                                     this.onClickOfMasterFile(data);
                                     }}
                                       >
                                                                      
                                    <GrFormView color="#69951a" fontSize="26px"/>
                                  </a>                         */}

                                  <a
                                    href="#"
                                    data-toggle="tooltip"
                                    data-placement="bottom"
                                    title="View"
                                    onClick={(e) => {
                                      // If formats not loaded yet OR file not supported, disable click
                                      if (!this.state.allowedFormat || !this.isViewSupported(data)) {
                                        e.preventDefault();
                                        return;
                                      }
                                  
                                      e.preventDefault();
                                      this.onClickOfMasterFile(data);
                                    }}
                                    style={{
                                      pointerEvents: (!this.state.allowedFormat || this.isViewSupported(data)) ? "auto" : "none",
                                      opacity: (!this.state.allowedFormat || this.isViewSupported(data)) ? 1 : 0.5,
                                      cursor: (!this.state.allowedFormat || this.isViewSupported(data)) ? "pointer" : "not-allowed",
                                      textDecoration: "none",
                                    }}
                                  >
                                    <GrFormView
                                      color={(!this.state.allowedFormat || this.isViewSupported(data)) ? "#69951a" : "#ccc"}
                                      fontSize="26px"
                                    />
                                  </a>
                                <a
                                  className="link-click"
                                  href="#"
                                  data-toggle="tooltip"
                                  data-placement="bottom"
                                  title="Download"
                                  onClick={() =>{if(!this.state.downloadingAttachments[data.id]){
                                    this.onClickOfAttachment(data)}
                                  }}
                                >
                                  <img src={downloadSvg} alt="" width="16" style={{opacity:this.state.downloadingAttachments[data.id]? 0.5:1}} />
                                </a>
                               
                                
                                {accessPermission &&
                                    accessPermission[245] ?  (
                                      <a
                                        className="link-click m-l-10"
                                        href="#"
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title="Email Notification"
                                        onClick={() =>
                                          this.onModalForEmail(data)
                                        }
                                      >
                                        <img
                                          src={Emailnotify}
                                          alt=""
                                          width="16"
                                        />
                                      </a>
                                    ):null}
                                </>
                                
                              )}
                            </td>
                          </tr>
                        );
                      })
                    : null}
                </tbody>
              </table>
            </div>
            {!pageOfItems.length && error ? <div>{error}</div> : null}
            {!pageOfItems.length && loading ? <div>Fetching...</div> : null}
            {!pageOfItems.length && !error && !loading ? (
              <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <Pagination
                  loading={loading}
                  items={pageOfItems}
                  pageSize={this.state.offset}
                  initialPage={this.state.currentPage}
                  onChangePage={this.onChangePage.bind(this)}
                />
              </div>
              <div
                className="col-md-2 form-group"
                style={{ display: "flex", marginTop: "8px" }}
              >
                <label style={{ marginTop: "8px" }}>Page Size: </label>
                <select
                  className="form-control"
                  style={{ width: "65px" }}
                  onChange={(e) => {
                    this.setState({ offset: parseInt(e.target.value) }, () => {
                      this.getListOfAttachment(
                        this.state.offset,
                        this.state.currentPage
                      );
                    });
                  }}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={25}>25</option>
                </select>
              </div>
            </div>
            <Modal
          visible={this.state.modalVisibleEmail}
          effect="fadeInDown"
          width="800"
        >
          <div style={{ padding: "20px" }}>
            <div className="modal-content" style={{ border: "none" }}>
              <div
                className="modal-body"
                style={{ paddingTop: 0, display: "" }}
              >
                <div className="col-10" style={{ display: "flex" }}>
                  <figure>
                    <img src={popupLogo} />
                  </figure>
                  <h1 className="heading m-l-45 m-b-35"  title={this.state.emailAttachment?.name} style={{wordBreak: "break-word"}}>
                    Send document <span style={{fontStyle:"italic"}}>{this.state.emailAttachment?.name?.length > 40
      ? this.state.emailAttachment.name.substring(0, 40) + "..."
      : this.state.emailAttachment?.name}</span> to below email/s:
                  </h1>
                </div>

                <div className="col-10" style={{ width: "82%" }}>
                  <div className="form-group">
                    <div
                      className="row"
                      style={{
                        display:
                          this.state.errors.length === 0 ? "none" : "block",
                      }}
                    >
                      <div className="col">
                        <div className="alert" role="alert">
                          <DisplayErrors errors={this.state.errors} />
                        </div>
                      </div>
                    </div>
                    <div className="ui-widget">
                      <InputComponent
                        required
                        type="text"
                        title="emailId"
                        name="inputEmail"
                        label="Enter valid e-mail"
                        value={emailProvider.inputEmail}
                        placeholder="abc@gmail.com , xyz@gmail.com"
                        handleChange={this.handleChange}
                        validator={this.validator}
                        //validation="required|email"
                        validation="required|multipleEmails"
                      />
                      {this.state.sending && (
                        <p
                          style={{
                            color: "black",
                            fontSize: "17px",
                            marginTop: "",
                            fontWeight:"600"
                            
                          }}
                        >
                          {/* Sending<span className="dot-flashing"></span> */}
                          <div className="uploading-container">
                            <span className="uploading-text">Sending</span>
                            <span className="uploading-dot dot-1">.</span>
                            <span className="uploading-dot dot-2">.</span>
                            <span className="uploading-dot dot-3">.</span>
                          </div>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default popup-button-default text-w-light"
                    data-dismiss="modal"
                    onClick={() => this.onEmailCancelModalVisible()}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger popup-button-danger"
                    onClick={() => this.sendEmail(emailAttachment)}
                    disabled={this.state.sending}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
            </>
          </div>
          
        ) : (
          accessSpecifier !=null && <NotAccessible />
        )}
      </>
    );
  }
}
export default withRouter(withApollo(CategoryList));
